module.exports = __webpack_public_path__ + "img/left-lightning12.0b0be6d0.png";